export enum AuthRole {
  VIEW = 'VIEW',
  MODIFY_RASN = 'MODIFY_RASN',
  RETRIGGER_EVENTS = 'RETRIGGER_EVENTS',
  SPECIAL_INSTRUCTION = 'SPECIAL_INSTRUCTION'
}

const roleHierarchy: Record<AuthRole, number> = {
  [AuthRole.VIEW]: 1,
  [AuthRole.MODIFY_RASN]: 2,
  [AuthRole.RETRIGGER_EVENTS]: 2,
  [AuthRole.SPECIAL_INSTRUCTION]: 2
}

export const hasSufficientRole = (role: AuthRole, targetRole: AuthRole): boolean => {
  return roleHierarchy[role] !== undefined && roleHierarchy[role] >= roleHierarchy[targetRole]
}

export const isAtMostRole = (role: AuthRole, targetRole: AuthRole): boolean => {
  return roleHierarchy[role] !== undefined && roleHierarchy[role] <= roleHierarchy[targetRole]
}
